<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <div class="nav-list">
        <div class="nav-item" :class="{'active': activeIndex === item.id}" v-for="item in typeList" :key="item.id"
          @click="handleClickNav(item)">{{item.name}}({{item.count}})</div>
      </div>

      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字 :" prop="fileName" placeholder="请输入">
              <el-input v-model="form.fileName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row type="flex">

          <!-- <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <el-button  type="primary">
              <svg-icon icon-class="add" />&nbsp;上传
            </el-button>
          </el-upload> -->
          <!-- <el-button round @click="exportList">
            <svg-icon icon-class="add" />&nbsp;下载
          </el-button> -->
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="(row)=>{ return row.schemeId }"
          :data="tableData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <!-- <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column> -->
          <el-table-column prop="activityName" label="活动名称" min-width="15%" show-overflow-tooltip></el-table-column>

          <el-table-column prop="fileName" label="附件名称" min-width="15%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fileFormat" label="格式" min-width="7%"></el-table-column>
          <el-table-column prop="fileShowSize" label="大小" min-width="12%"></el-table-column>
          <el-table-column prop="fileDownCount" label="下载次数" min-width="8%"></el-table-column>
          <el-table-column label="更新时间" min-width="10%">
            <template slot-scope="scope">{{ scope.row.updateDate | DateFormat('yyyy-MM-dd') }}</template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="16%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click.stop="view(scope.row)">预览</a>

              <a class="m-btn mr-10" @click.stop="addFile(scope.row, '重命名文件')">重命名</a>

              <a class="m-btn mr-10" @click.stop="downLoad(scope.row)">下载</a>

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogAddActivity ref="dialogAddActivity" @refresh="restList"></dialogAddActivity>
    <dialogActivityInfo ref="dialogActivityInfo" @refresh="restList"></dialogActivityInfo>
    <dialogQrcode ref="dialogQrcode" @refresh="restList"></dialogQrcode>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogAddActivity from './../activity-manage/dialog-add-activity'
import dialogActivityInfo from './../dialog-activity-info'
import dialogQrcode from '@views/collect2/out-storage/dialog-qrcode'
export default {
  components: {
    cmpMyExport,
    dialogAddActivity,
    dialogActivityInfo,
    dialogQrcode
  },
  data() {
    return {
      form: {
        fileName: ''
      },
      typeList: [],
      statusList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      configData: {
        tableName: 'activity'
      },
      total: 0,
      activeIndex: 0,
      id: '',
      tableData: [],
      chooseRowIds: '' // 当前导出选中藏品id
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$http
        .get('bsActivityFiledata/getFileListById', {
          ...this.form,
          ...this.listQuery,
          fileType: this.activeIndex
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (type === 'dele' && this.listQuery.currentPage > 1 && !res.result.length) {
              this.listQuery.currentPage -= 1
              this.initList()
              return
            }
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 上传回调 文件新增
    uploadCallback(item) {
      this.$http
        .post('/bsActivityFiledata/save', {
          id: this.id, //	项目ID
          fileId: item.attId //	文件夹名称
        })
        .then(res => {
          if (res.success) {
            this.restList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['activity_type', 'activity_status']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            // this.typeList = firstArr.concat(state['activity_type'])
            this.statusList = firstArr.concat(state['activity_status'])
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleClickNav(item) {
      this.activeIndex = item.id
      this.getTableList()
    },

    getActivityCount() {
      this.$http.get('bsActivityFiledata/countByType').then(res => {
        if (res.success) {
          this.typeList = res.result
        }
      })
    },

    // 上传
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 500MB!',
          type: 'warning'
        })
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.$http
          .post('/bsActivityFiledata/save', {
            id: this.id, //	项目ID
            fileId: res.result.attId //	文件夹名称
          })
          .then(res1 => {
            if (res1.success) {
              this.restList()
            } else {
              this.$message.error(res1.message)
            }
          })
      } else {
        this.$message.error(res.message)
      }
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '您正在删除附件，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .delete('/bsActivityFiledata/deleteFile', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('附件删除成功')
                this.initList('dele')
                this.getActivityCount()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    // 新增
    handleAdd(type, id) {
      if (type === 'detail') {
        this.$router.push({
          path: '/activity/activity-manage/detail',
          query: {
            id: id
          }
        })
      } else {
        this.$refs.dialogAddActivity.init(type, id)
      }
    },

    // 导出
    exportList() { },
    // 资料管理
    handleShowInfo(id) {
      this.$refs.dialogActivityInfo.init(id)
    },

    handleShare(id) {
      this.$refs.dialogQrcode.init(id, '2')
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.schemeId)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    },

    // 创建文件夹
    addFile(item, title) {
      let strName = item.fileName
      this.$prompt('', title || '创建文件夹', {
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
        inputValue: strName || null,
        inputPlaceholder: '文件名称',
        // inputPattern: /^[\S]{1,50}$/,
        inputPattern: /^.{1,50}$/,
        inputErrorMessage: '请输入1到50位字符'
        // center: true
      })
        .then(({ value }) => {
          if (strName) {
            this.modifyRemote(item, value)
          } else {
            this.addRemote(item, value)
          }
        })
        .catch(() => { })
    },

    addRemote(item, value) { },
    // 重命名文件夹
    modifyRemote(item, value) {
      // 文件类型(0:文件,1:文件夹)
      this.$http
        .put('/bsActivityFiledata/renameFile', {
          id: item.id, //	文件id
          fileRealname: value //	文件新名称
        })
        .then(res => {
          if (res.success) {
            this.$message.success('重命名文件成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 下载
    downLoad(item) {
      location.href = '/singleMuseum/bsActivityFiledata/download?id=' + item.id
    },

    view(item) {
      // window.open(item.filePath, '_blank')
    },
  },
  created() {
    this.initList()
    this.getDropdownValue()
    this.getActivityCount()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }
}
</style>